import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { addAuthenticateReducers } from "./async/authenticateThunk";
import { addMeReducers } from "./async/meThunk";
import { initialState } from "./initialState";
import { addChangePasswordFirstLoginReducers } from "./async/changePasswordFirstLoginThunk";

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setTokenAndMe: (state: any, action: PayloadAction<any>) => {
      const payload: any = action.payload;
      localStorage.setItem('token',payload.token)
      return {
        ...state,
        me: payload.me,
        token: payload.token,
        logged: payload.token == null ? false : true,
      };
    },
    setBlank: (state: any, action: PayloadAction<any>) => {
      return {
        ...state,
        blank: action.payload,
      };
    },
    logout: (_state: any, _action: PayloadAction<string>) => {
      localStorage.removeItem("token");
      _state = { ...initialState };
      return { ..._state, logged: false, errorMessage: "" };
    },
  },
  extraReducers: (builder) => {
    addAuthenticateReducers(builder);
    addMeReducers(builder);
    addChangePasswordFirstLoginReducers(builder);
  },
});
